import { get, readable, writable } from "svelte/store";
export default class Checkpoint {
    get id() {
        return this.checkpointState.id;
    }
    get name() {
        return this.checkpointState.name;
    }
    get icon() {
        return this.checkpointState.icon;
    }
    get image() {
        return this.checkpointState.image;
    }
    get desc() {
        return this.checkpointState.desc;
    }
    get coordinates() {
        return this.checkpointState.coordinates;
    }
    get interactiveDistance() {
        return this.checkpointState.interactiveDistance || null;
    }
    constructor(activitiesService, checkpointState) {
        this.activitiesService = activitiesService;
        this.checkpointState = checkpointState;
        this._isView = writable(false);
        this.isView = readable(false, set => this._isView.subscribe(set));
    }
    setView() {
        if (get(this._isView)) {
            return;
        }
        this._isView.set(true);
    }
    getActivities() {
        return Promise.all(this.checkpointState.activities.map(activityPath => {
            return this.activitiesService.loadActivity(activityPath);
        }));
    }
}
